<template>
  <div class="tab-container">
    General
  </div>
</template>

<script >
export default {
  name: 'ClimbingGroupsSupplyDetailGeneral',
}
</script>

